import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4e073a24&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&id=4e073a24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e073a24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e073a24')) {
      api.createRecord('4e073a24', component.options)
    } else {
      api.reload('4e073a24', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4e073a24&scoped=true&", function () {
      api.rerender('4e073a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/search/detail.vue"
export default component.exports